export default __webpack_public_path__ + "static/media/BG_TOP.ad351e2a.svg";